var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPdf = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m410.54 0v512h-383v-385.63l126.41-126.37z",
    fill: "#eaf2f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m291.04 0h119.5v512h-119.5z",
    fill: "#c6dcf8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m97.62 220.1h386.84v203.27h-386.84z",
    fill: "#fd4b49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m291.04 220.1h193.42v203.27h-193.42z",
    fill: "#e70b69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m163.332 387.978h-30v-130.918h47.733c24.25 0 43.979 19.729 43.979 43.979s-19.729 43.979-43.979 43.979h-17.733zm0-72.959h17.733c7.708 0 13.979-6.271 13.979-13.979s-6.271-13.979-13.979-13.979h-17.733z",
    fill: "#eaf2f9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m448.79 287.06v-30h-81.987v130.918h30v-42.959h41.32v-30h-41.32v-27.959z",
    fill: "#c6dcf8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m296.18 257.06h-47.65v130.49h47.65c24.3 0 44.06-19.76 44.06-44.06v-42.37c0-24.29-19.76-44.06-44.06-44.06zm14.06 86.43c0 7.76-6.31 14.06-14.06 14.06h-17.65v-70.49h17.65c7.75 0 14.06 6.31 14.06 14.06z",
    fill: "#eaf2f9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m205.6 112.67h137.44v30h-137.44z",
    fill: "#445ea0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m27.54 126.369h126.412v-126.369z",
    fill: "#c6dcf8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m340.24 301.12v42.37c0 24.3-19.76 44.06-44.06 44.06h-5.14v-30h5.14c7.75 0 14.06-6.3 14.06-14.06v-42.37c0-7.75-6.31-14.06-14.06-14.06h-5.14v-30h5.14c24.3 0 44.06 19.77 44.06 44.06z",
    fill: "#c6dcf8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m291.04 112.67h52v30h-52z",
    fill: "#224070"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf.3302cb27.svg";
export { ForwardRef as ReactComponent };